export default __webpack_public_path__ + "3c7021c0c5ae09671ff37976bad638cb.png";